export function getElementOffset(element: Element | EventTarget | null): { top: number; left: number } {
  if (element instanceof Element) {
    const rect = element.getBoundingClientRect();
    return { top: rect.top + window.scrollY, left: rect.left + window.scrollX };
  }
  return { top: 0, left: 0 };
}
